import React, { Fragment, useEffect, useRef, useState } from 'react';
import ReactPaginate from 'react-paginate';
import ListOfCallbacks from './ListOfCallbacks';
import SpecificComplaintDetails from './SpecificCallbackDetails';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Skeleton from '../common/Skeleton';
import getCallbackList from '../../../api/hospitality/Callback';
import { BiSortDown, BiSortUp } from 'react-icons/bi';
import SlidedScreen from '../../../common/SlidedScreen';
import { ImSpinner9 } from 'react-icons/im';

const Callback = () => {
  const companyUuid = sessionStorage.getItem('companyUuid');
  const itemsPerPage = 10;

  const [callbacks, setCallbacks] = useState<any>([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showLoading, setShowLoading] = useState(true);
  const [selectedCallbackInfo, setSelectedCallbackInfo] = useState<any>();
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('desc');
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [resetData, setResetData] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [scrollList, setScrollList] = useState(false);

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const scrollPositionRef = useRef<number>(0);
  const lastPageRef = useRef(currentPage);

  const pageCount = Math.ceil(totalItems / itemsPerPage);

  const handleFetchCallbacks = async (reset?: boolean, sort?: string) => {
    if (isFetching || !hasMore) return;
    setIsFetching(true);
    if (scrollContainerRef.current) {
      scrollPositionRef.current = scrollContainerRef.current.scrollTop;
    }
    try {
      if (!scrollList) {
        setShowLoading(true);
      }
      const data = await getCallbackList(
        companyUuid || '',
        currentPage,
        itemsPerPage,
        sort || sortOrder
      );
      // setCallbacks(data?.payload?.callbacks || []);
      // setSelectedCallbackInfo(data?.payload?.callbacks[0] || '');
      if (data?.payload?.callbacks.length > 0) {
        const list =
          resetData || reset ? data.payload.callbacks : [...callbacks, ...data.payload.callbacks];
        const ind = selectedCallbackInfo
          ? list.findIndex((ele: any) => ele.uuid === selectedCallbackInfo.uuid)
          : 0;
        setShowDetails(false);
        setCallbacks(list);
        setSelectedCallbackInfo(list[ind === -1 ? 0 : ind] || '');
        setTotalItems(data?.payload?.count || 0);
      } else {
        setHasMore(false);
      }
    } catch (error) {
    } finally {
      setShowLoading(false);
      setIsFetching(false);
      setResetData(false);
      setScrollList(false);
      setTimeout(() => {
        if (scrollContainerRef.current) {
          scrollContainerRef.current.scrollTop = scrollPositionRef.current;
        }
      }, 100);
    }
  };

  const handlePageClick = (event: { selected: number }) => {
    setCurrentPage(event.selected + 1);
  };

  useEffect(() => {
    lastPageRef.current = currentPage;
    handleFetchCallbacks();
  }, [currentPage]);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollContainerRef.current || isFetching || !hasMore) {
        return;
      }

      const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        if (callbacks.length < totalItems && lastPageRef.current === currentPage) {
          setScrollList(true);
          lastPageRef.current += 1;
          setCurrentPage((prev) => prev + 1);
        }
      }
    };

    const scrollableDiv = scrollContainerRef.current;
    if (scrollableDiv) {
      scrollableDiv.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (scrollableDiv) {
        scrollableDiv.removeEventListener('scroll', handleScroll);
      }
    };
  }, [isFetching, hasMore]);

  const handleSort = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    setResetData(true);
    if (currentPage === 1) {
      const sort = sortOrder === 'asc' ? 'desc' : 'asc';
      setSortOrder(sort);
      handleFetchCallbacks(true, sort);
    } else {
      setSortOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'));
      setCurrentPage(1);
    }
  };

  return (
    <>
      <div className="bg-[#1E1E1E] h-screen py-0 w-full md:px-2 overflow-y-auto xl:overflow-hidden relative">
        <div className="flex md:flex-row md:justify-normal justify-between items-center mb-2.5 px-2">
          <label className="text-base text-white font-medium">Callbacks</label>
          {callbacks.length > 0 && (
            <div className="flex justify-end xl:w-[34%] w-full">
              <div onClick={handleSort} className=" text-white font-bold px-2 rounded">
                {sortOrder === 'asc' ? (
                  <BiSortDown className="cursor-pointer w-[30px] h-[30px]" color={'#006BEA'} />
                ) : (
                  <BiSortUp className="cursor-pointer w-[30px] h-[30px]" color={'#006BEA'} />
                )}
              </div>
            </div>
          )}
        </div>
        {showLoading ? (
          <>
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="loader border-t-4 border-[#006BEA] rounded-full w-12 h-12 animate-spin"></div>
            </div>
            <Skeleton />
          </>
        ) : (
          <Fragment>
            {callbacks.length > 0 ? (
              <div className="bg-[#1E1E1E] w-full overflow-y-auto xl:overflow-hidden">
                <div className="flex flex-col xl:flex-row gap-2.5 xl:h-[calc(100vh-180px)] pb-2 xl:pb-0">
                  <div
                    ref={scrollContainerRef}
                    className="w-auto md:w-full lg:w-full xl:w-[40%] overflow-y-auto xl:h-[calc(100vh-180px)]  max-h-[80vh]"
                  >
                    <ListOfCallbacks
                      callbacks={callbacks || []}
                      selectedCallbackInfo={selectedCallbackInfo}
                      setSelectedCallbackInfo={(e: any) => { setSelectedCallbackInfo(e); setShowDetails(true); }}
                    />
                  </div>

                  <div className="w-[96%]  md:w-full xl:w-[58.5%] bg-[#343434] rounded-lg p-2 mt-2 ml-2 md:ml-0 hidden xl:block">
                    <SpecificComplaintDetails selectedCallbackInfo={selectedCallbackInfo} />
                  </div>
                  <SlidedScreen showDetails={showDetails} onClick={() => setShowDetails(false)} >
                    <SpecificComplaintDetails selectedCallbackInfo={selectedCallbackInfo} />
                  </SlidedScreen>
                </div>

                {isFetching && scrollList && (
                  <div className="flex justify-center lg:mt-3 md:gap-0 gap[-4px] xl:mb-1.5 w-full xl:w-[40%] mb-5 text-sm">
                    <div className='mr-2'>
                      <ImSpinner9 className="h-5 w-5 text-[#006BEA] animate-spin" />
                    </div>
                    Loading more data...
                  </div>
                )}

                {/* {callbacks.length > 0 && (
                  <div className="flex justify-center lg:mt-4 md:gap-0 gap[-4px] xl:mb-1.5 w-full xl:w-[40%] mb-36 text-sm">
                    <ReactPaginate
                      previousLabel={
                        <div className="flex items-center justify-center md:w-6 md:h-5 w-5 h-4 border rounded border-white text-white">
                          <FaChevronLeft />
                        </div>
                      }
                      nextLabel={
                        <div className="flex items-center justify-center md:w-6 md:h-5 w-5 h-4 border rounded border-white text-white">
                          <FaChevronRight />
                        </div>
                      }
                      pageCount={pageCount}
                      onPageChange={handlePageClick}
                      forcePage={currentPage - 1}
                      containerClassName="pagination flex space-x-6 mb-4"
                      pageLinkClassName="cursor-pointer"
                      activeLinkClassName="text-blue-500 font-bold"
                      disabledClassName="opacity-50 cursor-not-allowed"
                      previousClassName={currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}
                      nextClassName={
                        currentPage === pageCount ? 'opacity-50 cursor-not-allowed' : ''
                      }
                    />
                  </div>
                )} */}
              </div>
            ) : (
              <div
                className="flex content-center justify-center items-center h-4/6 overflow-y-hidden w-full text-gray-300 text-base font-normal
              select-none"
              >
                No records found
              </div>
            )}
          </Fragment>
        )}
      </div>
    </>
  );
};

export default Callback;
